// cdl-product.js
// Onglets description page produit - Ciel de Lin

document.addEventListener('DOMContentLoaded', function () {
  const tabBtns = document.querySelectorAll('.cdl-tabs__btn');
  const tabPanels = document.querySelectorAll('.cdl-tabs__panel');

  if (!tabBtns.length) return;

  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const target = btn.getAttribute('data-tab');

      // Désactiver tous les onglets
      tabBtns.forEach(function (b) { b.classList.remove('active'); });
      tabPanels.forEach(function (p) { p.classList.remove('active'); });

      // Activer l'onglet cliqué
      btn.classList.add('active');
      const panel = document.getElementById('cdl-tab-' + target);
      if (panel) panel.classList.add('active');
    });
  });
});
